/* eslint-disable @typescript-eslint/no-explicit-any */
import { convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'

import { mpfRListsHttp } from '../../../../assets/ts/api/mpf-r-lists-http'
import {
  Announcement,
  COLUMN_NAMES as AnnouncementsCols,
  LIST_NAME,
} from '../../../../assets/ts/data/announcements'
import { listAttachments } from '../../../../assets/ts/data/files/files'
import {
  validateDate,
} from '../../../../assets/ts/date-and-time/date-and-time'
import { convertRTE } from '../../../../assets/ts/formatting/formatting'
import { generateCode } from '../../../../assets/ts/general/general'
import {
  addToPIIAuditTrail,
  getPIIScanInfo,
  handlePIIValidationFailure,
  loadPII,
} from '../../../../assets/ts/pii/pii'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import FileUpload from '../../../../components/file-upload/file-upload'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import PIIPopup from '../../../../components/page-overlay/pii-popup'
import { MetadataContextInterface } from '../../../../store/metadata-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
} from '../../../../utils/constants/global-constants'
import { NO_CHANGE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import CustomSelect from '../../../../utils/controls/custom-select'
import InputText from '../../../../utils/controls/input-text'
import RichTextEditor from '../../../../utils/controls/rich-text-edit'
import { IsArchived, optionsTypes } from '../../../../utils/controls/select-options-data'

interface addOrEditProps {
  addOrEdit?: string
  announcement?: any
  announcements?: Announcement[]
  assignComponents?: MetadataContextInterface['components']
  assignedComponentOptions?: any
  cancel?: () => void
  categories?: MetadataContextInterface['categories']
  clickedIndex?: number
  filtersvalue?: any
  initialMajcomOptions?: any
  initialSectionOptions?: any
  initialSquadronOptions?: any
  majcoms?: MetadataContextInterface['majcoms']
  refresh?: boolean
  roleContext?: any
  sectionOption?: optionsTypes[]
  sections?: MetadataContextInterface['sections']
  setAnnouncements?: Dispatch<SetStateAction<Announcement[]>>
  setRefresh?: Dispatch<SetStateAction<boolean>>
  showAddPopup?: any
  showEdit?: any
  visibleSquadrons?: any
}

const AddEditView = ({
  announcement,
  announcements,
  assignedComponentOptions,
  cancel,
  categories,
  clickedIndex,
  filtersvalue,
  initialMajcomOptions,
  initialSectionOptions,
  refresh,
  roleContext,
  sections,
  setAnnouncements,
  setRefresh,
  showAddPopup,
  showEdit,
  visibleSquadrons
}: addOrEditProps) => {
  const editAnnouncement = announcement
  const titleRef: any = useRef<any>(null)
  const descriptionRef = useRef<any>(null)
  let oldAnnouncements = announcements || []
  const existingFiles = announcement?.Attachments[0]?.blobs
    ? announcement?.Attachments[0]?.blobs
    : []
  const [files, setFiles] = useState(
    announcement?.Attachments[0]?.blobs ? announcement?.Attachments[0]?.blobs : []
  )
  const [majcomOptions, setMajcomOptions] = useState<Array<optionsTypes>>([ALL_SELECT_OPTION])
  const [squadronOptions, setSquadronOptions] = useState<Array<optionsTypes>>(
    [ALL_SELECT_OPTION_STRING]
  )
  const [sectionOptions, setSectionOptions] = useState<Array<optionsTypes>>([ALL_SELECT_OPTION])
  const [categoryOptions, setCategoryOptions] = useState<Array<optionsTypes>>([])

  const [fileError, setFileError] = useState(false)
  const [replaceFile, setReplaceFile] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [showPageOverlay, setPageOverlay] = useState(false)

  const [inputValues, setInputValues] = useState({
    Archived: editAnnouncement?.IsArchived ? editAnnouncement?.IsArchived : false,
    AssignedComponent: editAnnouncement?.AssignedComponent
      ? editAnnouncement.AssignedComponent
      : ALL_SELECT_LABEL,
    AssignedComponentCode: editAnnouncement?.AssignedComponentCode
      ? editAnnouncement.AssignedComponentCode
      : ALL_SELECT_VALUE,
    CategoryCodeOptions: [],
    CategoryCodes: editAnnouncement?.CategoryCodes?.length > 0 ?
      editAnnouncement.CategoryCodes : [],
    Description: editAnnouncement?.Description ? editAnnouncement.Description : '',
    ExpiryDate: editAnnouncement?.ExpiryDate ? editAnnouncement?.ExpiryDate : '',
    SectionCodeOptions: [],
    SectionCodes: editAnnouncement?.SectionCodes?.length > 0 ?
      editAnnouncement.SectionCodes : [],
    ServicingMAJCOM: editAnnouncement?.ServicingMAJCOM ? 
      editAnnouncement.ServicingMAJCOM : ALL_SELECT_LABEL,
    ServicingMAJCOMCode: editAnnouncement?.ServicingMAJCOMCode ? 
      editAnnouncement.ServicingMAJCOMCode : ALL_SELECT_VALUE,
    Squadron: editAnnouncement?.ServicingOrganization
      ? editAnnouncement.ServicingOrganization
      : ALL_SELECT_VALUE_STRING,
    Tags: editAnnouncement?.Tags ? editAnnouncement.Tags : '',
    Title: editAnnouncement?.Title ? editAnnouncement?.Title : '',
  })

  useEffect(() => {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => assignedComponentOptions.length > 1 || (
          assignedComponentOptions.length === 1 &&
          assignedComponentOptions[0].value === item.assignedComponentCode
        )
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => maj.squadron.includes(e.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt?.majcom,
        squadron: filteredSectOpt?.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions = []
      majOptions.filter((majcom) => majcom.squadron).map((majcom) => {
        majcom.squadron?.map((item) => {
          squadOptions.push({
            label: item,
            value: item
          })
        })
      })
    

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    const categoryOptions = []

    sectOptions.forEach((section) => {
      categoryOptions.push(generateCategoryOptions(
        section.label,
        categories ?? [],
        sections ?? []
      ))
    })

    setCategoryOptions([...new Set(...categoryOptions)])
    handleChange('AssignedComponentCode', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].value ?? '' : -1)
    handleChange('AssignedComponent', assignedComponentOptions.length === 1 ? assignedComponentOptions[0].label ?? '' : '')
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value ?? '' : -1)
    handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label ?? '' : '')
    showAddPopup && handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : '')
    !showAddPopup && handleChange('Squadron', editAnnouncement?.ServicingOrganization === 'All' ? ALL_SELECT_VALUE_STRING : editAnnouncement?.ServicingOrganization)

  }, [
    assignedComponentOptions,
    initialMajcomOptions,
    initialSectionOptions,
    editAnnouncement
  ])


  const [announcementValidations, setAnnouncementValidations] = useState({
    Description: false,
    ExpiryDate: false,
    ExpiryDateMsg: '',
    Title: false,
  })
  const [displayValidation, setDisplayValidation] = useState({
    showPII: false,
  })

  const [piiScan, setPIIScan] = useState({})

  useEffect(() => {
    if (editAnnouncement) {
      setInputValues((prev) => ({
        ...prev,
        AssignedComponent: editAnnouncement?.AssignedComponent,
        AssignedComponentCode: editAnnouncement?.AssignedComponentCode,
        CategoryCodeOptions: editAnnouncement?.CategoryCodes?.map((categoryCode, index) => ({
          label: editAnnouncement?.Category?.split(', ')[index],
          value: categoryCode
        })),
        CategoryCodes: editAnnouncement?.CategoryCodes?.length > 0 ?
          editAnnouncement.CategoryCodes : [],
        SectionCodeOptions: editAnnouncement?.SectionCodes?.map((sectionCode, index) => ({
          label: editAnnouncement?.Section?.split(', ')[index],
          value: sectionCode
        })),
        SectionCodes: editAnnouncement?.SectionCodes?.length > 0 ?
          editAnnouncement.SectionCodes : [],
        ServicingMAJCOM: editAnnouncement?.ServicingMAJCOM,
        ServicingMAJCOMCode: editAnnouncement?.ServicingMAJCOMCode,
      }))
    }

  }, [editAnnouncement])

  const generateCategoryOptions = (
    sectionLabel: string | undefined,
    categories: MetadataContextInterface['categories'],
    sections: MetadataContextInterface['sections']
  ): optionsTypes[] => {
    const defaultOption = ALL_SELECT_OPTION

    if (!sectionLabel) return [defaultOption]

    const section = sections.find((metadata) => metadata.Label === sectionLabel)
    if (!section) return [defaultOption]

    const filteredCategories = categories.filter(
      (item) => item.ParentSectionCode === section.SectionCode
    )
    return [
      ...filteredCategories.map(({ Label, Value }) => ({
        label: Label,
        value: Value,
      })),
    ]
  }

  const handleChange = (key: string, value: boolean | number | string) => {
    setInputValues((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const changeSection = (e: { label: string; value: number }) => {
    const options = []

    e.forEach((section) => {
      options.push(generateCategoryOptions(
        section.label,
        categories ?? [],
        sections ?? []
      ))
    })

    setCategoryOptions([...new Set(...options)])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('SectionCodes', sectionOptions.length === 1 ? [sectionOptions[0].value] : [...e.map((section) => section.value)])
    handleChange('SectionCodeOptions', sectionOptions.length === 1 ? [sectionOptions[0]] : e)
  }

  const changeCategory = (e: { label: string; value: number }) => {
    handleChange('CategoryCodes', categoryOptions.length === 1 ? [categoryOptions[0].value] : [...e.map((category) => category.value)])
    handleChange('CategoryCodeOptions', categoryOptions.length === 1 ? [categoryOptions[0]] : e)
  }

  const changeAssignedComponent = (e: { label: string; value: number }) => {
    const majOptions: any[] = initialMajcomOptions
      .filter(
        (item) => item.assignedComponentCode === e.value || e.value === -1
      )
      .map((majcom) => ({
        assignedComponentCode: majcom.assignedComponentCode,
        label: majcom.label,
        squadron: majcom.squadron,
        value: majcom.value,
      }))

    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((e) => e.section === formattedSection &&
                majOptions.some((maj) => maj.squadron.includes(e.squadron)))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    const squadOptions = []
    majOptions.filter((majcom) => majcom.squadron).map((majcom) => {
      majcom.squadron?.map((item) => {
        squadOptions.push({
          label: item,
          value: item
        })
      })
    })

    if (majOptions.length > 1 && majOptions[0].value !== -1) {
      majOptions.unshift(ALL_SELECT_OPTION)
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setMajcomOptions(majOptions)
    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)

    handleChange('AssignedComponent', e.label)
    handleChange('AssignedComponentCode', e.value)
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('ServicingMAJCOM', majOptions.length === 1 ? majOptions[0].label ?? '' : ALL_SELECT_LABEL)
    handleChange('ServicingMAJCOMCode', majOptions.length === 1 ? majOptions[0].value ?? '' : ALL_SELECT_VALUE)
    handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)
  }

  const changeMajcom = (e: { label: string; value: number }) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection &&
              (e.squadron.includes(sect.squadron) || e.value === -1))) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    let squadOptions = []

    if (e?.squadron) {
      e.squadron?.map((item) => {
        squadOptions.push({
          label: item,
          value: item
        })
      })
    } else {
      squadOptions = []
      majcomOptions.map((majcom) => {
          majcom?.squadron?.map((item) => {
            squadOptions.push({
              label: item,
              value: item
            })
          })
        })
    }

    if (squadOptions.length > 1 && squadOptions[0].value !== -1) {
      squadOptions.unshift(ALL_SELECT_OPTION_STRING)
    }

    setSectionOptions(sectOptions)
    setSquadronOptions(squadOptions)
    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('ServicingMAJCOM', e.label)
    handleChange('ServicingMAJCOMCode', e.value)
    handleChange('Squadron', squadOptions.length === 1 ? squadOptions[0].value ?? '' : ALL_SELECT_VALUE_STRING)
  }

  const changeSquadron = (e: any) => {
    const sectOptions: optionsTypes[] = sections.filter((section) => {
      let containsSquadron = false

      Object.keys(visibleSquadrons).forEach((key) => {
        if (visibleSquadrons[key].length > 0) {
          const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

          if (key === 'SectionChief' || key === 'SectionOwner') {
            if (visibleSquadrons[key]
              .some((sect) => sect.section === formattedSection)) {
              containsSquadron = true
            }
          }
        }
      })

      return containsSquadron ||
        roleContext?.isCPOwner ||
        roleContext?.isLeadership ||
        roleContext?.isMPFOwner ||
        roleContext?.isMAJCOMOwner ||
        roleContext?.isAssignedComponentOwner
    }).map((section) => {
      const filteredSectOpt = initialSectionOptions.filter((sect) =>
        sect.value === section?.SectionCode
      )[0]

      return {
        label: section?.Section,
        majcom: filteredSectOpt.majcom,
        squadron: filteredSectOpt.squadron,
        value: section?.SectionCode,
      }
    })

    if (sectOptions.length > 1 && sectOptions[0].value !== -1) {
      sectOptions.unshift(ALL_SELECT_OPTION)
    }

    setSectionOptions(sectOptions)

    handleChange('SectionCodes', sectOptions.length === 1 ? [...sectOptions.map((section) => section.value)] ?? '' : [])
    handleChange('SectionCodeOptions', sectOptions.length === 1 ? sectOptions ?? '' : [])
    handleChange('CategoryCodes', [])
    handleChange('CategoryCodeOptions', [])
    handleChange('Squadron', e.value)
  }

  const changeTitle = (e: { target: { value: string } }) => {
    handleChange('Title', e.target.value)
  }

  const changeTag = (e: { target: { value: string } }) => {
    handleChange('Tags', e.target.value)
  }

  const changeDate = (e: { target: { value: string } }) => {
    handleChange('ExpiryDate', e.target.value)
  }

  const handleInputChangeRichText = (e) => {
    handleChange('Description', e)
  }

  const changeArchived = (e) => {
    handleChange('Archived', e.value)
  }

  const AnnouncementSubmit = async () => {
    let isValid = true
    let isNoChangesDetected = true
    let checkTitle = true
    let checkDescription = true
    let checkExpiryDate = true
    let checkExpiryMsg = ''
    const currentDate = new Date()
    const givenDate = new Date(inputValues.ExpiryDate)
    const previousDate = new Date(currentDate)
    previousDate.setDate(currentDate.getDate() - 1)

    setAnnouncementValidations({
      ...announcementValidations,
      Description: false,
      ExpiryDate: false,
      ExpiryDateMsg: '',
      Title: false,
    })

    if (!inputValues.Title || !inputValues.Title.trim()) {
      isValid = false
      checkTitle = false
    }
    if (
      !inputValues?.Description.getCurrentContent().hasText() ||
      !inputValues?.Description.getCurrentContent().getPlainText().trim()
    ) {
      isValid = false
      checkDescription = false
    }
    if (!inputValues.ExpiryDate) {
      isValid = false
      checkExpiryDate = false
      checkExpiryMsg = 'Please enter Expiry Date'
    } else if (!validateDate(inputValues.ExpiryDate)) {
      isValid = false
      checkExpiryDate = false
      checkExpiryMsg = 'Please enter valid Expiry Date'
    } else if (givenDate <= previousDate) {
      isValid = false
      checkExpiryDate = false
      checkExpiryMsg = 'Expiry Date should not less than the current Date'
    }
    if (
      editAnnouncement?.Title === inputValues.Title.trim() &&
      removeTags(editAnnouncement?.Description).trim() ===
      inputValues?.Description?.getCurrentContent()?.getPlainText()?.trim() &&
      editAnnouncement?.Tags?.trim() === inputValues?.Tags?.trim() &&
      editAnnouncement?.ExpiryDate.split('T')[0] === inputValues.ExpiryDate &&
      editAnnouncement?.IsArchived === inputValues?.Archived &&
      editAnnouncement?.SectionCodes.sort().join(',') === inputValues?.SectionCodes.sort().join(',') &&
      editAnnouncement?.CategoryCodes.sort().join(',') === inputValues?.CategoryCodes.sort().join(',') &&
      editAnnouncement?.ServicingMAJCOMCode === inputValues?.ServicingMAJCOMCode &&
      editAnnouncement?.AssignedComponentCode === inputValues?.AssignedComponentCode &&
      !isFilesChanged()
    ) {
      isValid = false
      isNoChangesDetected = false
    }
    if (!isNoChangesDetected) {
      setShowAlert(true)
    }
    setAnnouncementValidations({
      ...announcementValidations,
      Description: !checkDescription,
      ExpiryDate: !checkExpiryDate,
      ExpiryDateMsg: checkExpiryMsg,
      Title: !checkTitle,
    })

    if (isValid) {
      const piiIsValid = await validateAndHandlePIISubmission('submitted')
      await saveAnnouncements(piiIsValid)
    }
  }
  function removeTags(html: string) {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    return doc.body.textContent || ''
  }
  const generateString = (options: any) => {
    return JSON.stringify(options.map((options) => options.label))
  }

  const onClickAlert = async () => {
    setShowAlert(false)
  }
  function isFilesChanged() {
    const filesSet = new Set(files.map((file) => (file.fileName ? file.fileName : file.name)))
    const existingFilesSet = new Set(existingFiles.map((file) => file.fileName))
    const hasDifferences =
      existingFiles.some((aItem) => !filesSet.has(aItem.fileName)) ||
      files.some((aItem) => !existingFilesSet.has(aItem.fileName))
    return hasDifferences
  }
  async function saveAnnouncements(piiIsValid) {
    setPageOverlay(true)
    const userdetails = mpfRListsHttp().me()
    const userId = (await userdetails).userId
    const currentDate = new Date()
    const givenDate = new Date(inputValues.ExpiryDate)
    const addObj = {}
    addObj[AnnouncementsCols.Title] = inputValues.Title
    addObj[AnnouncementsCols.Description] = draftToHtml(
      convertToRaw(inputValues?.Description.getCurrentContent())
    )
    addObj[AnnouncementsCols.Tags] = inputValues.Tags
    addObj[AnnouncementsCols.AssignedComponentCode] = generateCode(
      inputValues.AssignedComponentCode
    )
    addObj[AnnouncementsCols.SectionCodes] = JSON.stringify(inputValues.SectionCodes)
    addObj[AnnouncementsCols.Section] = generateString(inputValues.SectionCodeOptions)
    addObj[AnnouncementsCols.ServicingMAJCOMCode] = generateCode(inputValues.ServicingMAJCOMCode)
    addObj[AnnouncementsCols.CategoryCodes] = JSON.stringify(inputValues.CategoryCodes)
    addObj[AnnouncementsCols.Category] = generateString(inputValues.CategoryCodeOptions)
    addObj[AnnouncementsCols.Squadron] = inputValues.Squadron
    addObj[AnnouncementsCols.IsArchived] = inputValues?.Archived ? inputValues?.Archived : false
    addObj[AnnouncementsCols.ItemModified] = currentDate
    addObj[AnnouncementsCols.ItemCreated] = currentDate
    addObj[AnnouncementsCols.ItemModifiedBy] = userId
    addObj[AnnouncementsCols.ItemCreatedBy] = userId
    addObj[AnnouncementsCols.EKey] = !editAnnouncement ? '' : editAnnouncement?.eKey
    addObj[AnnouncementsCols.ETag] = !editAnnouncement ? '' : editAnnouncement?.eTag
    addObj[AnnouncementsCols.ExpirationDate] = givenDate
    if (piiIsValid) {
      try {
        const annList = await mpfRListsHttp().getList(LIST_NAME)
        const actual = (await annList.addOrUpdateItem(addObj)) as Announcement
        addToPIIAuditTrail(
          'Settings-Announcements',
          editAnnouncement?.eKey,
          piiScan,
          userId
        )

        const itemkey = actual.eKey
        const newAnnouncements: Announcement = {
          ...actual,
          AssignedComponent: inputValues.AssignedComponent,
          AssignedComponentCode: generateCode(inputValues.AssignedComponentCode),
          Category: inputValues.CategoryCodeOptions.map((options) => options.label),
          CategoryCodes: inputValues.CategoryCodes,
          ExpirationDate: actual.ExpirationDate,
          Id: actual.eKey,
          Section: inputValues.SectionCodeOptions.map((options) => options.label),
          SectionCodes: inputValues.SectionCodes,
          ServicingMAJCOM: inputValues.ServicingMAJCOM,
          ServicingMAJCOMCode: generateCode(inputValues.ServicingMAJCOMCode),
          Squadron: inputValues.Squadron,
        }

        oldAnnouncements = oldAnnouncements.filter((item) => item.eKey !== newAnnouncements.eKey)
        if (editAnnouncement && isFilesChanged()) {
          const deletedFiles = existingFiles.filter(
            (aItem) => !files.some((bItem: any) => bItem.fileName === aItem.fileName)
          )
          try {
            const listname = await mpfRListsHttp().getList(LIST_NAME)
            for (const element of deletedFiles) {
              const deletedEtag = element.eTag
              await listname
                .blobs()
                .delete(editAnnouncement.eKey, element.fileName, element.folderName, deletedEtag)
            }
          } catch (error) {
            console.error('Error occurred while deleting attachment:', error)
          }
        }
        if (files?.length > 0) {
          const promises = []
          promises.push(listAttachments(LIST_NAME, itemkey, files))
          Promise.all(promises)
            .then(function () {
              cancel()
              oldAnnouncements.unshift(newAnnouncements)
              setAnnouncements(oldAnnouncements)
              setRefresh(!refresh)
              setPageOverlay(false)
            })
            .catch(function (error) {
              console.error(error)
            })
        } else {
          cancel()
          oldAnnouncements.unshift(newAnnouncements)
          setAnnouncements(oldAnnouncements)
          setRefresh(!refresh)
          setPageOverlay(false)
        }
      } catch (error) {
        console.error('error', error)
      }
    }
    setPageOverlay(false)
  }

  /**validateAndHandlePIISubmission
   * Validates the PII (Personally Identifiable Information) for submission and handles the submission process.
   *
   * @param {string} action - The action being performed (e.g., 'submitted').
   * @param {string} position - The position to displayValidation PII compliance validation messages ('top' or 'bottom').
   * @returns {boolean} - Indicates whether the submission can proceed.
   */
  const validateAndHandlePIISubmission = async (action = 'submitted') => {
    let canSubmit = true
    const piiScanData = {
      Description: convertRTE(inputValues?.Description),
      FileArray: Object.values(files),
      Title: inputValues.Title,
    }
    try {
      const uploadData = await getPIIScanInfo(piiScanData, piiScan)
      if (action === 'submitted') {
        setPIIScan({ ...uploadData.piiScanResult })
      }
      if (uploadData.canSubmit) {
        canSubmit = true
      } else {
        handlePIIValidationFailure(null, setDisplayValidation)
        canSubmit = false
      }
    } catch (error) {
      console.error('PII validation failed:', error)
      canSubmit = false
    }
    return canSubmit
  }

  useEffect(() => {
    const titleElemnt = document.getElementById('Title')
    if (titleRef?.current && titleElemnt) {
      if (clickedIndex === 0) {
        descriptionRef?.current?.scrollIntoView({ behavour: 'auto', block: 'end' })
        titleElemnt.focus()
      } else if (clickedIndex === 1) {
        descriptionRef?.current?.scrollIntoView({ behavour: 'auto', block: 'nearest' })
        titleElemnt.focus()
      } else {
        titleRef?.current?.scrollIntoView(false)
        titleElemnt.focus()
      }
    }
  }, [titleRef, showEdit, descriptionRef])

  useEffect(() => {
    setDisplayValidation((prev) => ({
      ...prev,
      showPII: false,
    }))
    if (Object.keys(piiScan).length > 0) {
      Object.keys(piiScan).forEach((key) => {
        if (key === 'FileArray') {
          for (const file of piiScan[key].value) {
            if (file?.resultsArray?.length > 0 && !file?.userAnswer) {
              setDisplayValidation((prev) => ({
                ...prev,
                showPII: true,
              }))
            }
          }
        } else {
          if (piiScan[key]?.resultsArray?.length > 0 && !piiScan[key]?.userAnswer) {
            setDisplayValidation((prev) => ({
              ...prev,
              showPII: true,
            }))
          }
        }
      })
    }
  }, [piiScan])

  useEffect(() => {
    loadPII()
  }, [])


  return (
    <div
      className={
        showAddPopup
          ? 'border-radius whitebg bordered15 mt-2'
          : 'settingseditpopup w-100 position-relative mt-2'
      }
      id='scroll'
    >
      {showAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={NO_CHANGE_MESSAGE}
          onClick={onClickAlert}
          yes='OK'
        />
      )}
      {showPageOverlay && <PageOverlayBusy />}
      {showAddPopup && (
        <div className='p-3 border-bottom4'>
          <h4
            aria-label='Add Announcements'
            className='m-0 p-0 d-inline-block font-15 poppins-semibold color-primary text-uppercase'
            tabIndex={0}
          >
            Add Announcements
          </h4>
        </div>
      )}
      {displayValidation.showPII && <PIIPopup piiScan={piiScan} setPIIScan={setPIIScan} />}
      <div className='px-2 py-1'>
        <div className='row'>
          <div className='col-sm-12 col-lg-12 mb-2' ref={titleRef}>
            <InputText
              changeHandler={changeTitle}
              error={announcementValidations.Title}
              formClassName='d-flex flex-column'
              info='Title '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'Title',
                name: ' Title',
                placeholder: 'Enter Title',
                value: inputValues.Title,
              }}
              isInfo
              isMandatory
              label=' Title '
            // ref={descriptionRef}
            />
          </div>
          <div className='col-sm-12 col-lg-12 mb-2' ref={descriptionRef}>
            <RichTextEditor
              defaultValue={undefined}
              editorValue={!showAddPopup ? editAnnouncement.Description : null}
              error={announcementValidations.Description}
              formClassName='d-flex flex-column'
              hint={announcementValidations.Description}
              info='Description '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Description ',
                name: ' Description',
                placeholder: 'Enter Description',
              }}
              isInfo
              isMandatory
              label='Description '
              sendValue={handleInputChangeRichText}
            />
          </div>
          <div className='col-sm-12 col-lg-12 mb-2'>
            <FileUpload
              filesProps={{ files, setFiles }}
              formClassName='d-flex flex-column'
              hint='Hint: Acceptable file types: docx, doc, pdf, txt, jpg, jpeg, png, xlsx, xls, pptx, ppt. The following special characters are not allowed in the document names: , ! @ # $ % ^ & * ( ) + = [ ] { } ‘ : “ \ | < > / ? ~. 
              Maximum file size is 25 MB. Maximum number of files is 10'
              hintClassName='color-primary'
              info='Attach file (s) '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: 'Attach files ',
                name: ' Description',
              }}
              isInfo
              label='Attach file (s) '
              note='Screenshots need to be saved locally before uploading into system'
              noteClassName='color-primary'
              replaceFileProps={{ replaceFile, setReplaceFile }}
              setFileError={setFileError}
            />
          </div>
          <div className='col-sm-12 col-lg-8 mb-2'>
            <InputText
              changeHandler={changeTag}
              formClassName='d-flex flex-column'
              info='Tags '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' Tags ',
                name: ' Tags',
                placeholder: 'Enter Tags',
                value: inputValues.Tags,
              }}
              isInfo
              label=' Tags '
            />
          </div>
          <div className='col-sm-12 col-lg-4 mb-2'>
            <InputText
              changeHandler={changeDate}
              errorMessage={announcementValidations.ExpiryDate}
              formClassName='d-flex flex-column'
              info='Expiry Date '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'poppins-medium font-12 title-color2 mb-1',
                id: ' ExpiryDate ',
                name: ' Expiry Date',
                placeholder: 'MM/DD/YYYY',
                value: inputValues.ExpiryDate,
              }}
              isInfo
              isMandatory
              label='Expiry Date '
              msg={announcementValidations?.ExpiryDateMsg}
              type='date'
            />
          </div>
          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='AssignedComponent'
              info='Assigned Component '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='AssignedComponent'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Assigned Component'
              onChange={changeAssignedComponent}
              options={assignedComponentOptions}
              value={inputValues?.AssignedComponentCode}
            />
          </div>

          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingMAJCOM'
              info='Servicing MAJCOM'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing MAJCOM'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing MAJCOM'
              onChange={changeMajcom}
              options={majcomOptions}
              value={inputValues?.ServicingMAJCOMCode}
            />
          </div>

          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              disabled={roleContext.isCPOwner || 
                roleContext.isAssignedComponentOwner || 
                roleContext.isMAJCOMOwner}
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='ServicingOrganization'
              info='Servicing Organization'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              label='Servicing Organization'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Servicing Organization'
              onChange={changeSquadron}
              options={squadronOptions}
              value={inputValues?.Squadron}
            />
          </div>

          <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='Section'
              info='Section '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMulti
              label='Section'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Section'
              onChange={(e: { value: string }) => {
                changeSection(e)
              }}
              options={sectionOptions}
              value={inputValues?.SectionCodeOptions}
            />
          </div>
          {inputValues.SectionCodes.length === 1 && <div className='col-sm-12 col-lg-4 mb-2'>
            <CustomSelect
              className='form-lg w-100 sourcesanspro font-13 customselect'
              formClassName='form-vertical text-nowrap poppins-semibold font-11'
              id='DashboardCategory'
              info='Category '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'mb-1 font-12 poppins-medium title-color',
              }}
              isInfo
              isMulti
              label='Category'
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              name='Category'
              onChange={changeCategory}
              options={categoryOptions}
              value={inputValues?.CategoryCodeOptions}
            />
          </div>}
          {!showAddPopup && (
            <div className='col-sm-12 col-lg-4 mb-2'>
              <CustomSelect
                className='form-lg w-100 sourcesanspro font-13 customselect'
                formClassName='form-vertical text-nowrap poppins-semibold font-11'
                id='IsArchived'
                info='IsArchived'
                infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                }}
                isInfo
                label='Is Archived'
                menuPortalTarget={document.body}
                menuPosition={'fixed'}
                name='Is Archived'
                onChange={changeArchived}
                options={IsArchived}
                value={inputValues?.Archived}
              />
            </div>
          )}
        </div>
        <div className='d-flex py-1 flex-wrap'>
          <div className='ms-auto settingsbtns d-flex'>
            {showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-save font-11 pe-1'
                  label='Save'
                  onClick={() => {
                    AnnouncementSubmit()
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    filtersvalue(!showAddPopup)
                  }}
                  type='button'
                />{' '}
              </>
            )}
            {!showAddPopup && (
              <>
                <Buttons
                  className='btn-border-radius3 py-1 px-3 btn-bgcolor9  ms-2 whitetext poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-update font-11 pe-1'
                  label='Update'
                  onClick={() => {
                    AnnouncementSubmit()
                  }}
                  type='button'
                />
                <Buttons
                  className='py-1 px-3 btn-border-radius3 btn-border1 ms-2 poppins-bold font-12 text-uppercase btn-xs'
                  icon='icon-close color-primary font-9 pe-1'
                  label='Cancel'
                  onClick={() => {
                    cancel()
                  }}
                  type='button'
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddEditView
